import { put } from 'redux-saga/effects'
import importer from 'common/importer'

const UserActions = importer('Stores/Users/Actions')
export default function * success ({ res }) {
    const { token_type, id_token } = res
    const authHeader = `${token_type} ${id_token}`
    yield put(UserActions.loginHeroku(authHeader))
}
